import { supabase } from '../integrations/supabase/client';
import { mapApiConfigToMarcaConfig } from '../utils/configHelpers';
import { MarcaConfig, MarcaConfigAPI } from '../utils/types';
import { getAppEnvironment } from '../utils/environment';

/**
 * Llama al Edge Function brand-settings para obtener la configuración de marca
 * desde el API externo usando BASIC auth (manejado en el Edge Function)
 */
export const fetchBrandConfiguration = async (brandKeyword: string): Promise<MarcaConfig> => {
  try {
    const { data, error } = await supabase.functions.invoke('brand-settings', {
      body: { brandKeyword, environment: getAppEnvironment() }
    });

    // Verificar si el Edge Function devolvió un error en el data (404, etc.)
    if (data && typeof data === 'object' && 'error' in data) {
      console.error('[BrandConfig] Edge Function error:', data.error);
      throw new Error(String(data.error));
    }

    if (error) {
      console.error('[BrandConfig] Error calling Edge Function:', error);
      // Si el mensaje de error indica 404, lanzarlo tal cual para que se detecte
      if (error.message?.includes('404') || error.message?.includes('not found')) {
        throw new Error('Brand not found - 404');
      }
      throw new Error(`Failed to fetch brand configuration: ${error.message}`);
    }

    if (!data) {
      console.error('[BrandConfig] No data returned from Edge Function');
      throw new Error('No data returned from brand settings API');
    }

    // Mapear de PascalCase (API) a camelCase (app)
    const mappedConfig = mapApiConfigToMarcaConfig(data as MarcaConfigAPI);
    
    return mappedConfig;
  } catch (err) {
    console.error('[BrandConfig] Exception during fetch:', err);
    throw err;
  }
};
